import { environment } from '@athlete-x/env/environment';

export const isGeneralDomain = () => {
    const currentDomain = globalThis?.location?.origin;
    const generalDomains = environment.generalDomains;

    return generalDomains.includes(currentDomain as any);
};
